import { Formik } from "formik";
import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Images from "../component/Images";
import { reviewSchema } from "../../utils/schema";
import { Rating } from "react-simple-star-rating";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import {
  curSym,
  pipErrorMessage,
  pipGetAccessToken,
  pipGetProfile,
  pipViewDate,
} from "../../utils/pip";
import NoRecord from "../../components/other/NoRecord";
import { useDispatch, useSelector } from "react-redux";
import ErrorMessage from "../../components/ErrorMessage";
import { useLocation, useNavigate } from "react-router-dom";
import ProductSection from "../getStarted/goodKitsToStart/ProductSection";
import {
  addToCart,
  fetchProductDetail,
  fetchRelatedProduct,
  sendProductFeedback,
} from "../../redux/action/orderAction";
import {
  decreaseProductQuantity,
  increaseProductQuantity,
} from "../../redux/reducers/orderReducer";
import { message } from "antd";
const ProductDetail = () => {
  const navigate = useNavigate();
  const productId = useLocation()?.state?.id;
  console.log({ productId });
  const dispatch = useDispatch();
  const { isLoading, productDetail } = useSelector(
    (state) => state?.orderReducer
  );

  const initialState = {
    // name: "",
    // email: "",
    review_text: "",
    rating: 0,
  };

  useEffect(() => {
    dispatch(fetchProductDetail(productId));
  }, []);
  useEffect(() => {
    dispatch(fetchRelatedProduct(productDetail?.related_name));
  }, [productDetail?.id]);

  const handleAddToCart = () => {
    if (pipGetAccessToken()) {
      const callback = (response) => {
        if (response.success);
        dispatch(fetchProductDetail(productId));
      };
      dispatch(
        addToCart({
          payload: {
            product_id: productDetail?.id,
            quantity: productDetail?.cartQuanity,
          },
          callback,
        })
      );
    } else {
      pipErrorMessage("You need to log in before adding items to the cart.");
      // navigate(pageRoutes?.login)
      return;
    }
  };

  const handleSendReview = async (values) => {
    if (pipGetAccessToken()) {
      const callback = (response) => {
        if (response.success) dispatch(fetchProductDetail(productDetail?.id));
      };

      dispatch(
        sendProductFeedback({
          payload: { ...values, product_id: productDetail?.id },
          callback,
        })
      );
    } else {
      message.error("You need to login to review the product");
      navigate(pageRoutes?.login);
      return;
    }
  };

  const hasUserReviewed = () => {
    const res = productDetail?.product_reviews?.some(
      (review) => review.user_id === pipGetProfile()?.id
    );
    return res;
  };
  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <>
        <section class="pt-5">
          <div class="container">
            <div class="row">
              <div class="col-md-6 mb-4">
                {console.log(productDetail?.product_images?.images)}
                {productDetail?.product_images?.images?.length > 0 && (
                  <Images images={productDetail?.product_images?.images} />
                )}
              </div>
              <div class="col-md-6 mb-4">
                <div class="ct_signle_product_detail">
                  <h5>{productDetail?.related_name}</h5>
                  <h3>{productDetail?.product_name}</h3>
                  <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
                    <div class="ct_review_star ">
                      <Rating
                      allowFraction
                        initialValue={parseFloat(productDetail?.total_rating) ?? 5}
                        readonly
                      />
                    </div>
                    <p class="mb-0">
                      {productDetail?.product_reviews?.length} Reviews
                    </p>
                  </div>
                  <h2>
                    {curSym}{" "}
                    {parseFloat(productDetail?.price) -
                      parseFloat(productDetail?.discount)}
                  </h2>
                  <p>{productDetail?.description ?? ""}</p>
                  <div>
                    <p class="mb-0">SKU: {productDetail?.sku}</p>
                    <p class="d-flex align-items-center flex-wrap gap-2 mb-0">
                      Category:{" "}
                      <span>{productDetail?.category?.category_name}</span>
                    </p>
                    <p class="d-flex align-items-center flex-wrap gap-2">
                      Sub Category:{" "}
                      <span>
                        {productDetail?.sub_category?.sub_category_name}
                      </span>
                    </p>
                  </div>
                  <div class="ct_flex_2">
                    <div
                      class="input-group ct_quntity_count1 d-flex align-items-center quantity-container ms-0"
                      style={{ maxWidth: "120px" }}
                    >
                      <div class="input-group-prepend">
                        <button
                          class="decrease"
                          type="button"
                          onClick={() =>
                            dispatch(decreaseProductQuantity(productDetail?.id))
                          }
                        >
                          −
                        </button>
                      </div>
                      <input
                        type="text"
                        class="form-control text-center quantity-amount"
                        value={productDetail?.cartQuanity}
                        placeholder="0"
                        aria-label="Example text with button addon"
                        aria-describedby="button-addon1"
                      />
                      <div class="input-group-append">
                        <button
                          class=" increase"
                          type="button"
                          onClick={() =>
                            dispatch(increaseProductQuantity(productDetail?.id))
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div>
                      <button
                        class="ct_single_cart_btn"
                        type="button"
                        onClick={handleAddToCart}
                      >
                        <i class="fa-solid fa-cart-shopping"></i> Add to cart
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="we-help-section ct_bg_grey py-5">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <ul
                  class="nav nav-pills mb-3 ct_description_tabs"
                  id="pills-tab"
                  role="tablist"
                >
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                    >
                      Description
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-profile"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      Reviews
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div class="ct_product_description">
                      <div>
                        <p>{productDetail?.description ?? ""}</p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <h5 class="my-4 text-dark"> Reviews</h5>
                    <div class="ct_review_user">
                      {productDetail?.product_reviews?.length > 0 ? (
                        productDetail?.product_reviews?.map((review) => {
                          return (
                            <div
                              class="ct_user_review_img "
                              key={review?.user_id}
                            >
                              <img
                                src={
                                  review?.user?.profile_image ??
                                  "images/user_profile.png"
                                }
                                alt=""
                              />
                              <div class="ct_user_review_cnt">
                                <div class="ct_review_user_name d-flex flex-wrap justify-content-between">
                                  <div>
                                    <h4 class="mb-2">{review?.user?.name}</h4>
                                    <h6>{pipViewDate(review?.created_at)}</h6>
                                  </div>
                                  <div class="ct_review_star mb-3">
                                    <Rating
                                      initialValue={review?.rating ?? 5}
                                      readonly
                                    />
                                  </div>
                                </div>
                                <p class="mt-2">{review?.review_text}</p>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <NoRecord />
                      )}
                    </div>
                    {!hasUserReviewed() && (
                      <div class="ct_give_reviews mt-5">
                        <h6>
                          Be the first to review “{" "}
                          <span>
                            {productDetail?.product_name ??
                              productDetail?.related_name ??
                              ""}
                          </span>
                          ”
                        </h6>
                        <p>
                          Your email address will not be published. Required
                          fields are marked *
                        </p>

                        {/* Review Form */}
                        <Formik
                          initialValues={initialState}
                          validationSchema={reviewSchema}
                          onSubmit={(values) => {
                            handleSendReview(values);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            setFieldValue,
                            handleBlur,
                            handleSubmit,
                          }) => (
                            <form onSubmit={handleSubmit}>
                              <div class="d-flex align-items-center gap-2 mb-3">
                                <p class="mb-0">Your Rating</p>
                                <Rating
                                  initialValue={values?.rating} // Controlled by state
                                  size={30}
                                  onBlur={handleBlur}
                                  onClick={(newRating) => {
                                    setFieldValue("rating", newRating);
                                  }}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="rating"
                                />
                              </div>
                              {/* <div class="ct_input-group mb-3">
                              <input
                                required=""
                                type="text"
                                name="name"
                                id="name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                                autocomplete="off"
                                class="ct_input ct_grey_input"
                              />
                              <label class="ct_user-label">Name</label>
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="name"
                              />
                              
                            </div>
                            <div class="ct_input-group mb-3">
                              <input
                                required=""
                                type="email"
                                name="email"
                                id="email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                autocomplete="off"
                                class="ct_input ct_grey_input"
                              />
                              <label class="ct_user-label">Email</label>
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="email"
                              />
                              
                            </div> */}
                              <div class="ct_input-group mb-3">
                                <textarea
                                  class="ct_input ct_grey_input"
                                  name=""
                                  rows="4"
                                  required=""
                                  id="review_text"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.review_text}
                                  autocomplete="off"
                                ></textarea>
                                <label class="ct_user-label">Your Review</label>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="review_text"
                                />
                                {/* <!-- <p class="ct_error_text">Please Enter Name</p> --> */}
                              </div>
                              <button
                                type="button"
                                onClick={handleSubmit}
                                class="btn btn-secondary ct_btn_animate"
                              >
                                Submit
                              </button>
                            </form>
                          )}
                        </Formik>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="we-help-section">
          <div class="container">
            <h2 class="section-title mb-4">
              <strong>Related Products</strong>
            </h2>
            <div class="row">
              <div class="col-md-12">
                <ProductSection
                  isSingleProductPage={true}
                  onClick={(id) => {
                    dispatch(fetchProductDetail(id));
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      </>
      <Footer />
    </div>
  );
};

export default ProductDetail;
